import type { InsuranceOfferWithSelectedState } from '@backmarket/http-api'

export function hasProtectionServiceOffers(
  insuranceOffers: InsuranceOfferWithSelectedState[],
): boolean {
  return insuranceOffers.some((offer) => offer.type === 'PROTECTION_SERVICE')
}
